import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query'
import { AccountGroupFilterKey } from 'api/Trading-Accounts/Types/AccountGroupDto'
import { BuildQueryProps } from 'utils/QueryHelpers'

export const normalizeAccountGroupsSearchQuery = (
  filterDescriptor?: FilterDescriptor[] | CompositeFilterDescriptor
): BuildQueryProps => {
  if (!filterDescriptor) {
    return {
      logic: 'and',
      filters: [],
    }
  }

  const gridFilterDescriptor = filterDescriptor as CompositeFilterDescriptor
  const filters = gridFilterDescriptor.filters.map(
    (x: FilterDescriptor | CompositeFilterDescriptor) => {
      const filterItem = x as FilterDescriptor

      if (filterItem.field === AccountGroupFilterKey.IS_ENABLED) {
        const value: boolean = filterItem?.value
        return {
          ...filterItem,
          value: value?.toString() ?? value,
        }
      }

      if (filterItem.field === AccountGroupFilterKey.IS_SWAP_FREE) {
        const value: boolean = filterItem?.value
        return {
          ...filterItem,
          value: value?.toString() ?? value,
        }
      }

      return filterItem
    }
  )

  return { ...gridFilterDescriptor, filters }
}
